import i from './about-us.container';

export default i;
